(() => {
  const normalize = (str) =>
    (str || "").toString().trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

  const keywordsPersonalizar = ["personalizar", "personalize agora", "sim", "quero", "customize", "customise", "customization", "yes"];

  function updateVisibility() {
    const wrappers = document.querySelectorAll('[data-personalizacao-wrapper]');

    wrappers.forEach(wrapper => {
      const radios = document.querySelectorAll('input[type="radio"]:checked');
      let mostrarCampos = false;

      radios.forEach(radio => {
        const val = normalize(radio.value);
        if (keywordsPersonalizar.some(k => val.includes(k))) {
          mostrarCampos = true;
        }
      });

      const nomeInput = wrapper.querySelector('input[name="properties[Name]"], input[name="properties[Nome]"]');
      const numeroInput = wrapper.querySelector('input[name="properties[Number]"], input[name="properties[Número]"]');

      if (mostrarCampos) {
        wrapper.classList.remove("hidden");
        wrapper.style.display = "block";
        if (nomeInput) nomeInput.disabled = false;
        if (numeroInput) numeroInput.disabled = false;
      } else {
        wrapper.classList.add("hidden");
        wrapper.style.display = "none";
        if (nomeInput) { nomeInput.value = ""; nomeInput.disabled = true; }
        if (numeroInput) { numeroInput.value = ""; numeroInput.disabled = true; }
      }
    });
  }

  // --- THE SECRET TO STOP THE FLICKER ---
  // We create an observer that detects when Dawn swaps the page content
  const observer = new MutationObserver((mutations) => {
    updateVisibility();
  });

  // Start observing the page body or the product form
  const productInfo = document.querySelector('product-info') || document.body;
  observer.observe(productInfo, { childList: true, subtree: true });
  // --------------------------------------

  // Keep the original events as a safety net
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"]')) {
       updateVisibility();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVisibility);
  } else {
    updateVisibility();
  }

  // Block re-rendering while typing (original behavior)
  document.addEventListener('change', (event) => {
    if (event.target.hasAttribute('data-no-render')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target.hasAttribute('data-no-render')) {
      event.stopImmediatePropagation();
    }
  }, true);
})();
